import { Button } from './lib/button.js';
customElements.define('cipublic-button', Button);
//# sourceMappingURL=cipublic-button.js.map